module.exports = __webpack_public_path__ + "static/ss13.891c617f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss13.jpg
// module id = 1190
// module chunks = 81679748166845